<template>
    <v-container
            grid-list-xs
    >

        <v-layout row wrap>
            <v-flex xs12 text-xs-center layout align-center justify-center>
                <h1>Vault</h1>
            </v-flex>
        </v-layout>




    </v-container>
</template>

<script>
    export default {
        name: 'vault',
        data() {
            return {};
        },
        computed: {},
        methods: {},
        created() {},
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Vault.vue?36cfc10e